<template>
    <div class='workroomIndex'>
        <div class="bbbbb1">
            <div class="bt">职位管理</div>
            <el-table :data="dataList" style="width: 95%">
                <el-table-column  prop="companyName" label="客户名称" width="120">
                </el-table-column>
                <el-table-column prop="positionName" label="职位名称" width="120">
                </el-table-column>
                <el-table-column prop="positionName" label="投递公司" width="150">
                    <template slot-scope="scope">
                        <div>{{ Number(scope.row.isCompany) === 1 ? (scope.row.companyNameCustom ?
                            scope.row.companyNameCustom : '某公司') :
                            scope.row.customCompanyName }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="len" label="投递数量" width="60">
                </el-table-column>
                <el-table-column label="运作顾问">
                    <template slot-scope="scope">
                       <div style="text-decoration: underline;text-underline-offset: 5px;cursor: pointer;" @click="getlinktype(scope.row)" >{{ scope.row.fullName }}</div>
                    </template>
                </el-table-column>
                <el-table-column  label="操作" width="300">
                    <template slot-scope="scope">
                        <!-- <el-button plain @click="getlinktype(scope.row)"  type="info">联系发布者</el-button> -->
                        <el-button plain @click="showUploadRes(scope.row)" type="info">投递简历</el-button>
                        <el-button plain @click="gopos(scope.row)" type="info">查看职位</el-button>
                        <!-- <el-button plain @click="handleClick(scope.row)" type="info">查看该职位做单详情</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin: 30px auto 0 auto; text-align: center;" @current-change="getmyjob"
                    :current-page="pageNumber1" :page-size="pageSize1" layout="total, prev, pager, next, jumper"
                    :total="pagetotal1">
                </el-pagination>
        </div>
        <div class="bbbbb1">
            <el-row :gutter="21" style="width: 95%">
                <el-col :span="3">
                    <div>
                        <el-statistic title="待处理">
                            <template slot="formatter">
                                {{ jobstaticArray[0].statusNum }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div>
                        <el-statistic title="已接收">
                            <template slot="formatter">
                                {{ jobstaticArray[1].statusNum }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div>
                        <el-statistic title="推荐数">
                            <template slot="formatter">
                                {{ jobstaticArray[2].statusNum }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div>
                        <el-statistic title="面试数">
                            <template slot="formatter">
                                {{ jobstaticArray[3].statusNum }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div>
                        <el-statistic title="已offer">
                            <template slot="formatter">
                                {{ jobstaticArray[4].statusNum }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div>
                        <el-statistic title="已入职">
                            <template slot="formatter">
                                {{ jobstaticArray[5].statusNum }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div>
                        <el-statistic title="已过保">
                            <template slot="formatter">
                                {{ jobstaticArray[6].statusNum }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
            </el-row>
        </div>


        <div class="bbbbb1">
            <el-tabs v-model="activeName" style="width: 95%">
                <el-tab-pane label="候选人管理" name="first">
                    <div class="bt">已投递管理 （{{ setitem === false ? '全部职位' : setitem.positionName }}）</div>
                    <el-table :data="reslist" style="width: 95%" height="400px">
                        <el-table-column  prop="resumeName" label="候选人" width="150">
                        </el-table-column>
                        <el-table-column prop="positionName" label="职位名称" width="120">
                        </el-table-column>
                        <el-table-column prop="nickname" label="运作顾问" width="240">
                        </el-table-column>
                        <el-table-column  label="当前状态">
                            <template slot-scope="scope">
                                <div v-if="Number(scope.row.status) === 1 && (scope.row.jobCandidateStatusEVoList === null || scope.row.jobCandidateStatusEVoList === undefined || scope.row.jobCandidateStatusEVoList.length <= 0 )">简历推荐中</div>
                                <div v-if="Number(scope.row.status) === 2 && (scope.row.jobCandidateStatusEVoList === null || scope.row.jobCandidateStatusEVoList === undefined || scope.row.jobCandidateStatusEVoList.length <= 0 )">简历推荐中</div>
                                <div v-if="Number(scope.row.status) === 3 && (scope.row.jobCandidateStatusEVoList === null || scope.row.jobCandidateStatusEVoList === undefined || scope.row.jobCandidateStatusEVoList.length <= 0 )">简历推荐中</div>
                                <div v-if="Number(scope.row.status) === 4">已面试</div>
                                <div v-if="Number(scope.row.status) === 5">已发offer</div>
                                <div v-if="Number(scope.row.status) === 6">已入职</div>
                                <div v-if="Number(scope.row.status) === 7">过保</div>
                                <div v-if="Number(scope.row.status) === 99">简历推荐中</div>
                                <div v-if="scope.row.jobCandidateStatusEVoList !== null && scope.row.jobCandidateStatusEVoList !== undefined && scope.row.jobCandidateStatusEVoList.length > 0 && scope.row.jobCandidateStatusEVoList[0].type === 1">简历被拒绝</div>
                                <div v-if="scope.row.jobCandidateStatusEVoList !== null && scope.row.jobCandidateStatusEVoList !== undefined && scope.row.jobCandidateStatusEVoList.length > 0 && scope.row.jobCandidateStatusEVoList[0].type === 2">简历通过</div>
                            </template>
                        </el-table-column>
                        <el-table-column  label="理由">
                            <template slot-scope="scope">
                                <div
                                    v-if="scope.row.jobCandidateStatusEVoList !== null && scope.row.jobCandidateStatusEVoList !== undefined && scope.row.jobCandidateStatusEVoList.length > 0 && scope.row.jobCandidateStatusEVoList[0].type === 1">
                                    拒绝理由: {{ scope.row.jobCandidateStatusEVoList[0].cause }}</div>
                                <div
                                    v-if="scope.row.jobCandidateStatusEVoList !== null && scope.row.jobCandidateStatusEVoList !== undefined && scope.row.jobCandidateStatusEVoList.length > 0 && scope.row.jobCandidateStatusEVoList[0].type === 2">
                                    通过理由: {{ scope.row.jobCandidateStatusEVoList[0].cause }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="职位公告" name="second">
                    <div class="bt">职位公告</div>
                    <el-empty v-if="zwgg.length <= 0" description="当前暂无职位公告"></el-empty>
                    <div class="fkBox">
                        <div class="tipbox" v-for="(item, index) in zwgg" :key="index">
                            <div class="boxtop">
                                <div class="topp1">
                                    {{ item.fullName }}
                                </div>
                                <div class="topp2">
                                    {{ item.xsTime }}
                                </div>

                            </div>
                            <div class="boxbottom">
                                {{ item.notice }}
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="相关职位" name="three">
                    <div class="bt">相关职位</div>
                    <el-table :data="xgposlist" style="width: 95%" height="400px">
                        <el-table-column fixed label="客户名称" width="150">
                            <template slot-scope="scope">
                                <div>{{ Number(scope.row.isCompany) === 1 ? (scope.row.companyNameCustom ?
                                    scope.row.companyNameCustom : '某公司') :
                                    scope.row.customCompanyName }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="positionName" label="职位名称" width="120">
                        </el-table-column>
                        <el-table-column prop="fullName" label="运作顾问" width="120">
                        </el-table-column>
                        <el-table-column fixed="right" label="操作">
                            <template slot-scope="scope">
                                <el-button plain @click="gopos(scope.row)" type="info">查看职位</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>

        </div>




        <el-dialog title="发布者信息" :modal-append-to-body="false" :visible.sync="dialogVisible" width="30%">
            <div>联系人：{{ setitem1.fullName ? setitem1.fullName : "暂无" }}</div>
            <div>联系电话：{{ setitem1.jobPhone ? setitem1.jobPhone : "暂无" }}</div>
            <div>微信号：{{ setitem1.jobWeixinAc ? setitem1.jobWeixinAc : "暂无" }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-drawer title="简历中心" :modal="false" :modal-append-to-body="false" :visible.sync="drawer" :direction="'rtl'"
            size="100%">
            <div class="jlzxbox">
                <div class="bt11">所有候选人<el-button type="primary" @click="goupload">前往上传简历</el-button></div>

                <el-table :data="jlLIst" style="width: 100%" height="60vh">
                    <el-table-column fixed prop="name" label="姓名" width="150">
                    </el-table-column>
                    <el-table-column prop="sex" label="性别" width="120">
                    </el-table-column>
                    <el-table-column prop="age" label="年龄" width="120">
                    </el-table-column>
                    <el-table-column prop="education" label="学历" width="120">
                    </el-table-column>
                    <el-table-column prop="workingLifeMax" label="工作经验" width="300">
                    </el-table-column>
                    <el-table-column prop="nowJob" label="最近职位" width="120">
                    </el-table-column>
                    <el-table-column prop="nowCompany" label="最近公司" width="120">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button @click="postRes(scope.row)" v-if="!scope.row.jobId" type="primary">投递</el-button>
                            <el-button v-if="scope.row.jobId" type="info">已投递</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-empty v-if="jlLIst.length <= 0" description="暂无简历"></el-empty>
                <el-pagination style="margin: 30px auto 0 auto; text-align: center;" @current-change="getResList"
                    :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                    :total="pagetotal">
                </el-pagination>
            </div>

        </el-drawer>
    </div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import moment from 'moment'
export default {
    name: 'workroom',
    props: {},
    data() {
        return {
            jobstaticArray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            userStatus: this.$store.state.userStatus,
            dataList: [],
            activeName: 'first',
            reslist: [],
            setitem1: false,
            setitem: false,
            setitem2: false,
            setitem3: false,
            jlList: [],
            dialogVisible: false,
            drawer: false,
            jlLIst: [],
            zwgg: [],
            pageSize1: 5,
            pageNumber1: 1,
            pagetotal1: 0,
            pageSize: 15,
            pageNumber: 1,
            pagetotal: 0,
            mwidth: {
                1: '75px',
                2: '225px',
                3: '375px',
                4: '525px',
                5: '675px',
                6: '825px',
                7: '910px',
                99: '75px',
            }
        }
    },
    computed: {
        userStatusfunc() {
            return this.$store.state.userStatus;
        }
    },
    watch: {
        userStatusfunc(val) {
            this.userStatus = val
        },
    },
    created: function () { },
    methods: {
        getmyjob: function () {
            let that = this
            that.loading = true
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/getMyJobList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json',
                },
                data: { pageSize: that.pageSize1, pageNum: that.pageNumber1 },
            })
                .then((res) => {
                    that.loading = false
                    if (res.data.success === '1') {
                        let newlist = []
                        let demoList = []
                        demoList = res.data.content.list
                        for (let item in demoList) {
                            var a = moment()
                            var b = moment(demoList[item].createTime)
                            if (a.diff(b, 'days') >= 1) {
                                if (
                                    moment(demoList[item].createTime).format('YYYY') ===
                                    moment().format('YYYY')
                                ) {
                                    demoList[item].xsTime =
                                        moment(demoList[item].createTime).format('MM月DD日') + ' '
                                } else {
                                    demoList[item].xsTime =
                                        moment(demoList[item].createTime).format('YYYY年MM月DD日') +
                                        ' '
                                }
                            } else if (a.diff(b, 'hours') >= 1) {
                                demoList[item].xsTime = a.diff(b, 'hours') + '小时前 '
                            } else if (a.diff(b, 'minutes') >= 1) {
                                demoList[item].xsTime = a.diff(b, 'minutes') + '分钟前 '
                            } else {
                                demoList[item].xsTime = '刚刚 '
                            }
                            if (demoList[item].label) {
                                demoList[item].tagss = demoList[item].label.split(':')
                            } else {
                                demoList[item].tagss = []
                            }
                        }
                        for (let i in demoList) {
                            let flag = false
                            for (let j in newlist) {
                                if (demoList[i].id === newlist[j].id) {
                                    newlist[j].len++
                                    flag = true;
                                }
                            }
                            if (!flag) {
                                demoList[i].len = 1
                                newlist.push(demoList[i])
                            }
                        }
                        that.pagetotal1 =  res.data.content.total
                        that.dataList = newlist
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
                .catch((err) => {
                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },
        handleClick: function (item) {
            this.setitem = item
            this.reslist = []
            this.getreslist()
            this.getGztInfo()
            this.getxgposlist()
        },
        getreslist: function () {
            let that = this
            that.loading = true
            let data = { pageSize: 200, pageNum: 1 }
            if (that.setitem === false) {

            } else {
                data.jobId = that.setitem.id
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/getCandidateProgressList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json',
                },
                data: data
            })
                .then((res) => {
                    that.loading = false
                    if (res.data.success === '1') {
                        that.reslist = res.data.content.list
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
                .catch((err) => {
                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },
        getGztInfo: function () {
            let that = this
            that.loading = true
            let data = { pageSize: 200, pageNum: 1 }
            if (that.setitem === false) {

            } else {
                data.jobId = that.setitem.id
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/countJobStatusByJobId',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json',
                },
                data: data
            })
                .then((res) => {
                    that.loading = false
                    if (res.data.success === '1') {
                        that.jobstaticArray = res.data.content
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
                .catch((err) => {
                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },
        getlinktype: function (item) {
            

            if (!localStorage.getItem('token')) {
                window.location.href = 'https://www.pinkuaikuai.cn/login.html'
            } else {
                this.dialogVisible = true
                this.setitem1 = item
            }
        },
        showUploadRes: function (item) {
            if (!localStorage.getItem('token')) {
                window.location.href = 'https://www.pinkuaikuai.cn/login.html'
            } else {
                this.pageNumber = 1
                this.pagetotal = 0
                this.drawer = true
                this.setitem2 = item
                this.getResList()
            }
        },
        load: function () {
            if (this.jlLIst.length < this.pagetotal) {
                this.pageNumber = this.pageNumber + 1
                this.getResList()
            }
        },
        gopos: function (item) {
            this.$router.push({
                name: 'job',
                params: { id: item.id }
            })
        },
        getResList: function () {
            let that = this
            that.loading = true
            let data = {
                pageSize: that.pageSize,
                pageNum: that.pageNumber,
                jobId: that.setitem2.id
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/myResumeList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json',
                },
                data: data,
            })
                .then((res) => {
                    that.loading = false
                    if (res.data.success === '1') {
                        let demoList = []
                        if (that.pageNumber === 1) {
                            demoList = res.data.content.list
                        } else {
                            demoList = dataList.concat(res.data.content.list)
                        }
                        that.pagetotal = res.data.content.total
                        that.jlLIst = demoList
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
                .catch((err) => {
                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },
        deleteRes: function (item) {
            let that = this
            that.loading = true
            this.$confirm('确认删除该简历？')
                .then(_ => {
                    let data = {
                        id: item.id
                    }
                    axios({
                        method: 'POST',
                        url: Config.path + '/api/candidate/delResume',
                        headers: {
                            token: localStorage.getItem('token'),
                            'content-type': 'application/json',
                        },
                        data: data,
                    })
                        .then((res) => {
                            that.loading = false
                            if (res.data.success === '1') {
                                that.pageNumber = 1
                                that.pagetotal = 0
                                that.getResList()
                            } else {
                                that.$message.error(res.data.message)
                            }
                        })
                        .catch((err) => {
                            that.loading = false
                            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                        })
                })
                .catch(_ => { });
        },
        postRes: function (item) {
            let that = this
            that.loading = true
            this.$confirm('确认投递该简历？')
                .then(_ => {
                    let data = {
                        resumeId: item.id,
                        jobId: that.setitem2.id
                    }
                    axios({
                        method: 'POST',
                        url: Config.path + '/api/candidate/resumeDeliver',
                        headers: {
                            token: localStorage.getItem('token'),
                            'content-type': 'application/json',
                        },
                        data: data,
                    })
                        .then((res) => {
                            that.loading = false
                            if (res.data.success === '1') {
                                that.pageNumber = 1
                                that.pagetotal = 0
                                that.getResList()
                            } else {
                                that.$message.error(res.data.message)
                            }
                        })
                        .catch((err) => {
                            that.loading = false
                            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                        })
                })
                .catch(_ => { });
        },
        goupload: function () {
            this.$router.push({
                name: 'upload',
            })
        },
        getZwGg: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/getmyNoticeList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    pageNum: 1,
                    pageSize: 100
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    let demoList = []
                    demoList = res.data.content.list
                    for (let item in demoList) {
                        var a = moment()
                        var b = moment(demoList[item].createTime)
                        if (a.diff(b, 'days') >= 1) {
                            if (
                                moment(demoList[item].createTime).format('YYYY') ===
                                moment().format('YYYY')
                            ) {
                                demoList[item].xsTime =
                                    moment(demoList[item].createTime).format('MM月DD日 HH:mm') +
                                    ' '
                            } else {
                                demoList[item].xsTime =
                                    moment(demoList[item].createTime).format(
                                        'YYYY年MM月DD日 HH:mm'
                                    ) + ' '
                            }
                        } else if (a.diff(b, 'hours') >= 1) {
                            demoList[item].xsTime = a.diff(b, 'hours') + '小时前 '
                        } else if (a.diff(b, 'minutes') >= 1) {
                            demoList[item].xsTime = a.diff(b, 'minutes') + '分钟前 '
                        } else {
                            demoList[item].xsTime = '刚刚 '
                        }
                    }
                    that.zwgg = demoList
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        getxgposlist: function () {
            let that = this
            that.loading = true
            let data = { pageSize: 200, pageNum: 1 }
            if (that.setitem === false) {

            } else {
                data.customCompanyId = that.setitem.customCompanyId
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/getCustomCompanyjobList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json',
                },
                data: data
            })
                .then((res) => {
                    that.loading = false
                    if (res.data.success === '1') {
                        that.xgposlist = res.data.content.list
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
                .catch((err) => {
                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        }
    },
    mounted: function () {
        this.getmyjob()
        this.getGztInfo()
        this.getreslist()
        this.getZwGg()
        this.getxgposlist()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.workroomIndex {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    justify-content: flex-start;
    background-size: cover;
    background-attachment: fixed;
    flex: 1;
    padding-bottom: 100px;

    .bbbbb1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #ffffff;
        width: 70vw;
        margin-top: 40px;
        padding: 20px 20px;
    }

    .bt {
        font-size: 20px;
        font-weight: bold;
        padding-left: 20px;
        height: 26px;
        line-height: 26px;
        border-left: 5px solid #5dc1cf;
        margin-bottom: 30px;
        margin-top: 30px;
        width: 95%;
    }

    .contbox {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100vw;
        flex: 1;

        .el-tabs {
            flex: 0.9;
            width: 80vw;
            height: 100%;
        }

        .linebox {
            width: 910px;
            display: flex;
            margin: 0 auto;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            margin-top: 30px;

            .line {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 910px;
                height: 5px;
                background-color: #b9b9b9;
                position: relative;

                .dot {
                    width: 10px;
                    height: 10px;
                    background-color: #b9b9b9;
                    border-radius: 100%;
                }

                .drawline {
                    width: 910px;
                    height: 5px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-color: #5dc2d0;
                }
            }

            .textline {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 910px;
                position: relative;
                margin-top: 10px;

                .t {
                    font-size: 12px;
                    color: #b9b9b9;
                }
            }
        }


        .topbtnbox {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            width: 90%;
            top: 30px;
            right: 30px;


            .actionbtn1 {
                background-color: rgb(27, 192, 109);
                color: #fff;
                margin-right: 20px;
                padding: 0 20px;
                height: 40px;
                line-height: 40px;
                border-radius: 5px;
                text-align: center;
                cursor: pointer;

                i {
                    color: #ffffff;
                    margin-right: 5px;
                }
            }

            .actionbtn2 {
                background-color: red;
                color: #fff;
                margin-right: 20px;
                padding: 0 20px;
                height: 40px;
                line-height: 40px;
                border-radius: 5px;
                text-align: center;
                cursor: pointer;

                i {
                    color: #ffffff;
                    margin-right: 5px;
                }
            }

            .actionbtn3 {
                background-color: rgb(14, 214, 171);
                color: #fff;
                margin-right: 20px;
                padding: 0 20px;
                height: 40px;
                line-height: 40px;
                border-radius: 5px;
                text-align: center;
                cursor: pointer;

                i {
                    color: #ffffff;
                    margin-right: 5px;
                }
            }

            .actionbtn4 {
                background-color: rgb(97, 178, 216);
                color: #fff;
                margin-right: 20px;
                padding: 0 20px;
                height: 40px;
                line-height: 40px;
                border-radius: 5px;
                text-align: center;
                cursor: pointer;

                i {
                    color: #ffffff;
                    margin-right: 5px;
                }
            }


            .bt11 {
                width: 100%;
                font-size: 20px;
                font-weight: bold;
                padding-left: 20px;
                height: 50px;
                line-height: 50px;
                border-left: 5px solid #5dc1cf;
                margin-bottom: 30px;
                margin-top: 30px;
                position: relative;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .btn {
                    cursor: pointer;
                    width: 120px;
                    height: 36px;
                    font-size: 18px;
                    line-height: 36px;
                    border-radius: 36px;
                    background-color: #5dc1cf;
                    color: #ffffff;
                    text-align: center;
                }
            }
        }

    }

    .fkBox {
        width: 90%;
        padding: 30px;
        box-sizing: border-box;
        border-radius: 10px;
        margin: 30px auto;



        .title {
            color: #4d4d4d;
            font-weight: bold;
            margin-bottom: 10px;
        }

        .tip {
            color: #4d4d4d;
        }

        .tipbox {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            margin: 0px 0 30px 0;

            .boxtop {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                width: 100%;

                .topp1 {
                    color: #4d4d4d;
                    font-size: 18px;
                    font-weight: bold;
                    margin-right: 10px;
                    cursor: pointer;
                }

                .topp2 {
                    color: #4d4d4d;
                    font-size: 18px;
                    font-weight: bold;
                    cursor: pointer;
                }

                .close {
                    color: red;
                }

                .pass {
                    color: green;
                }
            }

            .boxbottom {
                margin-bottom: 20px;
                color: #000000;
            }
        }
    }
}
</style>
